module.exports = __webpack_public_path__ + "media/images/pic/video/2-c96220b21bc2dbdd18e650421adb0bb2.jpeg";